import Edit from "@mui/icons-material/Edit";
import PersonRemove from "@mui/icons-material/PersonRemove";
import { colors } from "healthex-common/colors";
import styled from "styled-components";
import { HXMenuButton } from "./HXMenuButton";
import { FlexColumnDiv, FlexRowDiv } from "./common.styles";
export const AdminAPIKeysViewParent = styled(FlexColumnDiv) `
    gap: 16px;
`;
export const IntroAndActionsRow = styled.div `
    display: flex;
    align-items: flex-start;
    gap: 64px;
    margin-top: 16px;

    & > *:last-child {
        flex-shrink: 0;
    }
`;
export const IntroText = styled.div `
    flex: 1;
    min-width: 0;
    color: ${colors.black_light};
`;
export const ActionButton = styled(HXMenuButton).attrs({ secondary: true, startIcon: null, label: "" }) `
    border-color: ${colors.black_12};
    color: ${colors.black_lighter};
    padding: 8px;
    min-width: 0;

    &:hover {
        border-color: ${colors.black_lighter};
    }

    & .MuiButton-endIcon {
        margin: 0;
    }
`;
export const EditIcon = styled(Edit) `
    &&& {
        color: ${colors.black_lighter};
    }
`;
export const RemoveIcon = styled(PersonRemove) `
    li:not(.Mui-disabled) && {
        color: ${colors.tulip_main};
    }
`;
export const DestructiveText = styled.div `
    li:not(.Mui-disabled) & {
        color: ${colors.tulip_main};
    }
`;
export const AvatarAndName = styled(FlexRowDiv) `
    align-items: center;
    gap: 8px;
`;
